// tslint:disable:no-any

import React, { Component } from 'react';
import GoogleMapReact from 'google-map-react';
import MapPoint, { getMapProps } from '../components/MapPoint';
import DivesMapDetailModal from '../components/DivesMapDetailModal';
import {
    DEFAULT_MAP_CENTER,
    DEFAULT_MAP_ZOOM
} from '../constants/MapVariables';

export interface IDivesMapProps {
    dives: any;
    sharedDives: any;
    viewDetail: any;
    viewSharedDetail: any;
}

interface IDivesMapState {
    center: any;
    zoom: number;
    dives: any;
    sharedDives: any;
    diveDetail: any;
    diveDetailShared: any;
}
class DivesMap extends Component<IDivesMapProps, IDivesMapState> {
    constructor(props: IDivesMapProps) {
        super(props);

        this.state = {
            dives: props.dives.userDives,
            sharedDives: props.sharedDives.sharedDives,
            diveDetail: null,
            // data pro mapu
            center: DEFAULT_MAP_CENTER,
            zoom: DEFAULT_MAP_ZOOM,
            diveDetailShared: undefined
        };
    }

    componentWillReceiveProps(nextProps: IDivesMapProps) {
        this.setState({
            dives: nextProps.dives.userDives,
            sharedDives: nextProps.sharedDives.sharedDives
        });
    }

    viewDetailModal(dive: any, shared: any) {
        this.setState({
            diveDetail: dive,
            diveDetailShared: shared
        });
    }

    render() {
        const { viewDetail, viewSharedDetail } = this.props;
        let allDives = [...this.state.dives];
        allDives = allDives.concat([...this.state.sharedDives]);
        
        let mapProps = {
            center: this.state.center,
            zoom: this.state.zoom
        };

        if (allDives.length > 0) {
            mapProps = getMapProps(allDives);
        }

        let sharedPoints = this.state.sharedDives.map(
            (dive: any, index: number) => {
                const lat = Number(dive.latitude);
                const lng = Number(dive.longitude);
                if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
                    return (
                        <MapPoint
                            key={index}
                            shared={true}
                            lat={lat}
                            lng={lng}
                            onClick={() => this.viewDetailModal(dive, true)}
                        />
                    );
                }
                return null;
            }
        );

        let points = this.state.dives.map((dive: any, index: number) => {
            const lat = Number(dive.latitude);
            const lng = Number(dive.longitude);
            if (!Number.isNaN(lat) && !Number.isNaN(lng)) {
                return (
                    <MapPoint
                        shared={false}
                        key={index}
                        lat={lat}
                        lng={lng}
                        onClick={() => this.viewDetailModal(dive, false)}
                    />
                );
            }
            return null;
        });

        return (
            // tslint:disable-next-line:jsx-no-string-ref
            <div ref="map" className="dashboard__map">
                <GoogleMapReact
                    /*style={{
                        height: '100%',
                        width: '100%',
                        display: 'block'
                    }}
                    scrollwheel={false}*/
                    resetBoundsOnResize={true}
                    bootstrapURLKeys={{
                        key: (window as any).__REACT_SETTINGS.googleMapsApiKey
                    }}
                    center={mapProps.center}
                    zoom={mapProps.zoom}
                >
                    {points}
                    {sharedPoints}
                </GoogleMapReact>

                <DivesMapDetailModal
                    display={this.state.diveDetail !== null}
                    dive={this.state.diveDetail}
                    shared={this.state.diveDetailShared}
                    viewDetail={() => viewDetail(this.state.diveDetail.id)}
                    viewSharedDetail={() =>
                        viewSharedDetail(this.state.diveDetail.id)
                    }
                />
            </div>
        );
    }
}

export default DivesMap;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DivesMap.tsx